import { render, staticRenderFns } from "./GoodsClass.vue?vue&type=template&id=6faa4164&scoped=true"
import script from "./GoodsClass.vue?vue&type=script&lang=js"
export * from "./GoodsClass.vue?vue&type=script&lang=js"
import style0 from "./GoodsClass.vue?vue&type=style&index=0&id=6faa4164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa4164",
  null
  
)

export default component.exports